import { createIntl, createIntlCache } from '@formatjs/intl';
import type { Locale } from './locales.ts';
import { en } from './messages/en.ts';
import type { MessageKey } from './messages/en.ts';
import { nbNO } from './messages/nb-NO.ts';

export * from './format.ts';
export * from './locales.ts';
export type { MessageKey };

export const catalogues: Record<Locale, Record<MessageKey, string>> = { en, 'nb-NO': nbNO };

const cache = createIntlCache();

/** A formatter for code outside React (API errors, exports). React code uses react-intl with `catalogues`. */
export function intlFor(locale: Locale) {
  return createIntl({ locale, messages: catalogues[locale], defaultLocale: 'en' }, cache);
}
